// 엣지 API 출처. 운영은 웹=엣지 동일 출처라 빈 문자열(상대경로). dev는 :8787(별도 wrangler).
export const EDGE_BASE = (import.meta.env.VITE_EDGE_BASE ?? "").replace(/\/$/, "");

/** 게시본 우선 fetch: 엣지(게시본, 항상 최신) → 없으면 정적 파일(캐시 허용, M1 오프라인·성능).
 *  ok+JSON이면 게시본 사용. 실시간 푸시가 신선도를 보장하므로 정적은 캐시해도 안전. */
export async function fetchPublishedFirst(
  apiPath: string,
  staticPath: string,
): Promise<unknown | null> {
  const attempts: Array<{ url: string; init: RequestInit }> = [
    { url: `${EDGE_BASE}${apiPath}`, init: { cache: "no-store" } },
    { url: staticPath, init: { cache: "force-cache" } },
  ];
  for (const { url, init } of attempts) {
    try {
      const res = await fetch(url, init);
      if (res.ok) return await res.json();
    } catch {
      /* 다음 후보 */
    }
  }
  return null;
}

/**
 * 📋 **목록 문서는 둘 다 받아 온다** — 게시본과 저장소 파일을 **합치기 위해**서다.
 *
 * 🔴 `fetchPublishedFirst` 는 **먼저 답한 쪽만** 쓴다. 한 문서(책 한 권·구역 맵 하나)에는
 * 그게 맞다 — 운영자가 고친 판이 이겨야 하니까. 그런데 **목록**에 그러면
 * 「게시본에 하나라도 있으면 저장소 목록이 통째로 사라지는」 사고가 된다.
 * 책에서 실제로 났다(2026-08-21: 빈 책 한 권이 진짜 책 두 권을 지웠다).
 *
 * 목록은 둘 다 받아 `mergeById` 로 합친다. 둘 다 실패했을 때만 「못 받았다」다.
 */
export async function fetchBothForMerge(
  apiPath: string,
  staticPath: string,
): Promise<{ published: unknown | null; repo: unknown | null; offline: boolean }> {
  const one = async (url: string, init: RequestInit): Promise<unknown | null> => {
    try {
      const res = await fetch(url, init);
      return res.ok ? await res.json() : null;
    } catch {
      return null;
    }
  };
  const [published, repo] = await Promise.all([
    one(`${EDGE_BASE}${apiPath}`, { cache: "no-store" }),
    one(staticPath, { cache: "force-cache" }),
  ]);
  // 🔴 게시본이 없는 것(아직 아무것도 안 올렸다)은 실패가 아니다 — 둘 다 없을 때만 실패다
  return { published, repo, offline: published === null && repo === null };
}
